import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import './RegisterStyles.css';

// Known teams list
const knownTeams = [
    "EMINENTS WC",
    "Kampala International University (KIU)",
    "NDEJJE CORPORATE WC",
    "MAKERERE UNIVERSITY",
    "KISUBI CORPORATE",
    "UNIVERSITY OF KISUBI",
    "BUGEMA UNIVERSITY",
    "MUBS WC",
    "PRISONS WC",
    "BANK OF UGANDA",
    "DIGEL WC",
    "Uganda National Examinations Board",
    "VISION GROUP",
    "AIRFORCE SS",
    "Islamic University In Uganda",
    "Ministry of Public Service"
];

const Register = () => {
    const [formData, setFormData] = useState({
        teamName: '',
        players: '',
        contact: '',
        email: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [suggestions, setSuggestions] = useState([]);
    const [isNewTeam, setIsNewTeam] = useState(true);
    const { currentUser } = useAuth();

    // Filter known teams based on user input
    useEffect(() => {
        if (formData.teamName.length > 2) {
            const matchedTeams = knownTeams.filter(team => 
                team.toLowerCase().includes(formData.teamName.toLowerCase())
            );
            setSuggestions(matchedTeams.slice(0, 5)); // Limit to 5 suggestions
            
            // Check if exact match exists
            const exactMatch = knownTeams.some(
                team => team.toLowerCase() === formData.teamName.toLowerCase()
            );
            setIsNewTeam(!exactMatch);
        } else {
            setSuggestions([]);
            setIsNewTeam(true);
        }
    }, [formData.teamName]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    
    const selectTeam = (team) => {
        setFormData({ ...formData, teamName: team });
        setSuggestions([]);
        setIsNewTeam(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage({ text: '', type: '' });
        
        try {
            // Get the current user's auth token
            const token = await currentUser.getIdToken();
            
            // Include whether this is a known team in the submission
            const submissionData = {
                ...formData,
                isKnownTeam: !isNewTeam
            };
            
            // Send the token in the Authorization header
            await axios.post('https://woodball-586444644604.us-central1.run.app/register', submissionData, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            
            setMessage({ 
                text: 'Registration successful! Your team is now pending approval.', 
                type: 'success' 
            });
            setFormData({ teamName: '', players: '', contact: '', email: '' });
        } catch (error) {
            console.error('Registration error:', error);
            setMessage({ 
                text: error.response?.data?.error || 'Error registering team. Please try again.', 
                type: 'error' 
            });
        }
        setIsSubmitting(false);
    };

    return (
        <div className="register-container">
            <div className="register-card">
                <h2 className="register-title">Event Registration</h2>
                {message.text && (
                    <div className={`message ${message.type}`}>
                        {message.text}
                    </div>
                )}
                <form onSubmit={handleSubmit} className="register-form">
                    <div className="form-group">
                        <label htmlFor="teamName">Team Name</label>
                        <div className="team-input-wrapper">
                            <input 
                                type="text" 
                                id="teamName"
                                name="teamName" 
                                placeholder="Enter your team name" 
                                onChange={handleChange} 
                                value={formData.teamName} 
                                required 
                                autoComplete="off"
                            />
                            {suggestions.length > 0 && (
                                <div className="team-suggestions">
                                    {suggestions.map((team, index) => (
                                        <div 
                                            key={index} 
                                            className="team-suggestion"
                                            onClick={() => selectTeam(team)}
                                        >
                                            {team}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {!isNewTeam && (
                            <div className="known-team-badge">
                                ✓ Known Team
                            </div>
                        )}
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="players">Players</label>
                        <textarea 
                            id="players"
                            name="players" 
                            placeholder="Enter player names (comma-separated)" 
                            onChange={handleChange} 
                            value={formData.players} 
                            required 
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="contact">Contact Person</label>
                        <input 
                            type="text" 
                            id="contact"
                            name="contact" 
                            placeholder="Enter contact person's name" 
                            onChange={handleChange} 
                            value={formData.contact} 
                            required 
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input 
                            type="email" 
                            id="email"
                            name="email" 
                            placeholder="Enter contact email" 
                            onChange={handleChange} 
                            value={formData.email} 
                            required 
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        className="submit-btn" 
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Submitting...' : 'Register Team'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Register;